import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sp-chips-suggestions',
    templateUrl: './suggestions.component.html',
    styleUrls: ['./suggestions.component.scss'],
})
export class SuggestionsComponent {
    @Input() suggestions: any[];
    @Input() displayValue = 'name';

    @Output() selectSuggestion = new EventEmitter<any>();

    onSuggestionClick(suggestion: any) {
        this.selectSuggestion.emit(suggestion);
    }
}
